import { ApiError } from "api/apiError";

// API エラーをユーザー向け日本語文言へ変換する。
// 方針（execplans/2026-06-09-api-error-feedback-plan.md §2）:
// - BE の生 message は出さない（英語・内部語彙・未展開プレースホルダ・typo を含むため）。
// - キーは「HTTP status × operation」。将来 BE が stable な error code を返すように
//   なれば code 優先へ拡張する（#30）。
// - status 単位の汎用文言を基本とし、主要 operation のみ固有文言で上書きする。

// 入力の形式・値の不正を示す汎用文言。L の入力チェック失敗は 400 から 422 に変わった（issue #52）ため、
// 両方の status で同じ文言を使い、登録系の表示（FailedItemsList）も同じ定数を参照する。
export const INVALID_INPUT_MESSAGE = "入力内容に誤りがあります。値をご確認のうえ、再度お試しください。";

const GENERIC_BY_STATUS: Record<number, string> = {
    400: INVALID_INPUT_MESSAGE,
    422: INVALID_INPUT_MESSAGE,
    401: "認証の有効期限が切れている可能性があります。再ログインしてください。",
    403: "この操作の権限がない、または認証の有効期限が切れています。再ログインしてください。",
    404: "対象のデータが見つかりませんでした。",
    409: "既に存在するため、処理できませんでした。",
};

// `${operation}:${status}` で個別上書きする固有文言。
const SPECIFIC: Record<string, string> = {
    "createCalcSet:409": "その計算 ID は既に存在します。ID を変更してください。",
    "createCalcSet:400": "入力内容に誤りがあります。Mount 数や Correction Direction をご確認ください。",
    "patchCalcSetDesc:404": "対象の計算セットが見つかりませんでした。",
    "deleteCalcSet:404": "対象の計算セットが見つかりませんでした。",
};

const SERVER_ERROR = "サーバーでエラーが発生しました。時間をおいて再度お試しください。";
const NETWORK_ERROR = "通信に失敗しました。ネットワーク環境をご確認のうえ、再度お試しください。";

export const toUserMessage = (error: unknown): string => {
    if (error instanceof ApiError) {
        const specific = SPECIFIC[`${error.operation}:${error.status}`];
        if (specific) return specific;
        if (error.status >= 500) return SERVER_ERROR;
        const generic = GENERIC_BY_STATUS[error.status];
        if (generic) return generic;
        return `処理に失敗しました（エラーコード: ${error.status}）。時間をおいて再度お試しください。`;
    }
    // ApiError 以外（fetch reject = ネットワーク断 / タイムアウト / CORS、想定外の例外）。
    return NETWORK_ERROR;
};

export const toUploadErrorMessage = (error: unknown): string => {
    if (error instanceof ApiError) return toUserMessage(error);
    if (error instanceof Error && error.message) return error.message;
    return toUserMessage(error);
};
